import { FormStore } from 'bz-draft';
import { action } from 'mobx';
import { inject, observer, Provider } from 'mobx-react';
import React from 'react';
import Dialog from 'tm3-core/controls/modal/core-dialog';

import Preview from './controls/preview';
import SnippetItem from './controls/snippet-item';

import './style.css';

@inject('draftStore', 'dialogStore')
@observer
class SnippetDialog extends React.Component {
  constructor(props) {
    super(props);
    this.preview = new FormStore(props.draftStore.controls);
  }

  render() {
    const { snippets = [] } = this.props.draftStore;

    const content = snippets.map((x, i) => {
      return <SnippetItem key={i} snippet={x} />;
    });

    return (
      <Provider preview={this.preview}>
        <div className="snippet-dialog">
          <div className="snippet-items">{content}</div>
          <Preview />
        </div>
      </Provider>
    );
  }
}

@inject('dialogStore')
@observer
class DialogWrapper extends React.Component {
  render() {
    let { open } = this.props.dialogStore;

    return (
      <Dialog
        open={open}
        title="Insert a Snippet"
        onClose={this.onRequestClose}
        onCloseButtonClick={this.onRequestClose}
        onRequestClose={this.onRequestClose}
      >
        <SnippetDialog />
      </Dialog>
    );
  }

  @action.bound
  onRequestClose() {
    this.props.dialogStore.open = false;
  }
}

export default DialogWrapper;
